import { FunctionComponent } from "react";
import { Box, Button } from "@mui/material";
import { colorGrayLight } from "../../styles/theme";
import RelevancyScore from "./RelevancyScore";
import CardActionsMenu from "./CardActionsMenu";
import CopyButton from "./CopyButton";
import TranslateToggle from "./TranslateToggle";
import BasketIcon from "../Icons/Basket";
import ChatSelectButton from "../ChatBot/ChatSelectButton";

interface CardItemProps {
	score: number;
	isInBasket: boolean;
	onAddToBasket: () => void;
	onCopyFullText?: () => Promise<void>;
	translateOn?: boolean;
	onToggleTranslate?: () => void;
	translateLoading?: boolean;
	showChatSelect?: boolean;
	chatSelected?: boolean;
	onToggleChatSelect?: () => void;
	actionsVariant?: "menu" | "buttons";
}

const CardHead: FunctionComponent<CardItemProps> = ({
	score,
	isInBasket,
	onAddToBasket,
	onCopyFullText,
	translateOn,
	onToggleTranslate,
	translateLoading,
	showChatSelect,
	chatSelected,
	onToggleChatSelect,
	actionsVariant = "menu",
}) => {
	return (
		<Box
			sx={{
				display: "flex",
				gap: "10px",
				height: "42px",
				marginBottom: "4px",
			}}
		>
			<Box sx={{ width: "60px" }}>
				<Box sx={{ position: "absolute", top: "-18px" }}>
					<RelevancyScore score={score} />
				</Box>
			</Box>
			<Box
				sx={{
					display: "flex",
					flex: 1,
					alignItems: "center",
					justifyContent: "flex-end",
					gap: "5px",
				}}
			>
				{showChatSelect && (
					<ChatSelectButton
						selected={!!chatSelected}
						onToggle={onToggleChatSelect}
					/>
				)}
				{actionsVariant === "menu" ? (
					<CardActionsMenu
						onCopyFullText={onCopyFullText}
						translateOn={translateOn}
						onToggleTranslate={onToggleTranslate}
						translateLoading={translateLoading}
						isInBasket={isInBasket}
						onAddToBasket={onAddToBasket}
					/>
				) : (
					<>
						{onCopyFullText && <CopyButton onCopy={onCopyFullText} />}
						{onToggleTranslate && (
							<TranslateToggle
								active={!!translateOn && !translateLoading}
								onToggle={onToggleTranslate}
								loading={translateLoading}
							/>
						)}
						<Button
							variant="outlined"
							onClick={onAddToBasket}
							sx={{
								borderRadius: "10px",
								width: "50px",
								height: "40px",
								backgroundColor: isInBasket ? colorGrayLight : "transparent",
								"&:hover": {
									backgroundColor: isInBasket ? colorGrayLight : undefined,
								},
							}}
						>
							<BasketIcon sx={{ width: 20, height: 19, cursor: "pointer" }} />
						</Button>
					</>
				)}
			</Box>
		</Box>
	);
};

export default CardHead;
